module.exports = __webpack_public_path__ + "diamond-text-fill.svg?95e54a1021180678781e07c2d613c9d7";